import { render, staticRenderFns } from "./addTwo.vue?vue&type=template&id=82a938fa&scoped=true&"
import script from "./addTwo.vue?vue&type=script&lang=js&"
export * from "./addTwo.vue?vue&type=script&lang=js&"
import style0 from "./addTwo.vue?vue&type=style&index=0&id=82a938fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a938fa",
  null
  
)

export default component.exports